<template>
  <div></div>
</template>

<script>
export default {
  methods: {
    logout() {
      this.$store
        .dispatch('logout')
        .then(() => this.$router.push('/login'))
        .catch(err => console.log(err));
    }
  },
  mounted() {
    this.logout();
  }
};
</script>

<style scoped>
</style>